module.exports = __webpack_public_path__ + "static/media/20180523-LCS-052-26.0c764ab1.jpg";